module.exports = __webpack_public_path__ + "img/phox3.53c4047a.png";